module.exports = __webpack_public_path__ + "img/undraw_empty_re_opql@2x.eb1854a8.png";